import styled from 'styled-components';

interface ContainerProps {
  width: string;
}

export const Container = styled.div<ContainerProps>`
  width: ${props => props.width};
  display: flex;
  align-items: flex-start;
  flex-direction: column;
  padding: 0.6rem;

  @media (max-width: 850px) {
    width: 100%;
  }

  label {
    width: 100%;
    text-align: left;
    font-weight: 500;
    font-size: 0.8rem;
    color: var(--stone-600);
  }

  select {
    width: 100%;
    padding: 0.6rem 0.75rem;
    border: 1px solid var(--border);
    border-radius: var(--radius-sm);
    text-align: left;
    margin-top: 0.4rem;
    background: #fff;
    font-family: var(--font-sans);
    font-size: 0.9rem;
    color: var(--foreground);
    transition: border-color 0.15s, box-shadow 0.15s;

    &:focus {
      border-color: var(--primary);
      box-shadow: 0 0 0 3px rgba(255, 188, 3, 0.3);
    }
  }
`;
